<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">Suppliers List</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <h4>
                <i class="fa fa-list-ul"></i>
                Supplier List
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">

          <div class="row">
            <div class="col-md-12">
             <div style="display:flex">
              <label style="line-height: 2.5;">VendorType:</label> 
                  <select
                    class="form-control"
                    v-model="vendorType"
                    name="vendor_type"
                  >
                    <option id="vendor-type" selected value=""
                      >Choose Type</option>
                    <option
                      v-for="type in typeList"
                      :key="type.type_id"
                      v-bind:value="type.type_id">
                      {{ type.type_name }}</option
                    >
                  </select>
                </div>
            </div>
          </div>
          <hr/>
          
            <div class="co-md-12">
                <div class="section">
                    <b-table id="item-table"
                      :fields="fields"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      :filter="filter"
                      hover
                      :items="filteredList" 
                      :per-page="perPage"
                      :current-page="currentPage">
                      <!-- A virtual column -->
                      <template #cell(sno)="data">
                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                      </template>
                      <template #cell(action)="data">
                        <a
                          v-on:click="showForm(data.item.supplier_id)"
                          class="btn label-warning btn-xs"
                          style="float: left;display: block; width: 100%;"
                          ><i class="fa fa-edit"></i> Edit</a
                        >
                      </template>
                    </b-table>
                  <!-- Show pagination links -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rowCount"
                      :per-page="perPage"
                      aria-controls="item-table"
                      hide-ellipsis
                      ></b-pagination>
                <json-excel 
                  v-if="rowCount"
                  class="btn btn-success"
                  style="float: right;"
                  :data="filteredList"
                  :fields="exportFields"
                  name="supplier-list.xls"
                  >
                  Export
                </json-excel>
                </div>
            </div>

        </div> 
      </section>
    </section>
  </section>
</template>

<script>

import api from "../api";
import { BTable, BPagination } from 'bootstrap-vue'
import JsonExcel from "vue-json-excel";

export default {
  name: "SupplierList",
  components: {
    BPagination,
    BTable,
    JsonExcel
  },
  data() {
    return {
      itemList: [],
      typeList: [],
      vendorType: "",
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'supplier_name', label: 'Supplier Name'},
        { key:'supplier_address', label: 'Address'},
        { key:'supplier_phone', label: 'Phone'},
        { key:'supplier_email', label: 'Email'},
        ],
      exportFields: {
        'Supplier Name': 'supplier_name',
        'Address': 'supplier_address',
        'Phone': 'supplier_phone',
        'Email': 'supplier_email'
      }
    };
  },
  methods: {
    getVendorTypes: function() {
      const list = {filter: {}};
      api
        .request("post", "GeneralApis/get_vendor_types", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.typeList = response.data.values;
          } else {
            this.typeList = data.typeList;
          }
        });
    },
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_suppliers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.supplierList;
            this.totalRows = this.itemList.length
          }
        });
    },
    showForm: function(supplierid) {
      console.log(supplierid);
      this.itemId = supplierid;
      this.showFormModal = true;
    },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
  },
  computed: {
    filteredList: function () {
     const list = this.itemList.filter((item) => {
       const typeFilter = this.vendorType ? item.vendor_type == this.vendorType : true
       return typeFilter
     });
     return list
    },
    rowCount: function () {
      return this.filteredList.length
    }
  },
  mounted(){
    this.getList()
    this.getVendorTypes()
  }
};
</script>
